import $ from 'jquery';

class Navigation {
  constructor() {
    this.nav = $('.js-nav');

    if (!this.nav.length) {
      return;
    }

    this.navDropdowns = this.nav.find('.js-nav-dropdown');
    this.navLinks = this.nav.find('.js-nav-link');
    this.navToggler = $('.js-nav-toggler');

    this.debounce = null;
    this.debounceInterval = 500;
    this.breakpoint = 1024;
    this.navType = 'hover';
    this.initialNavType = this.navType;

    this.header = $('.js-header');

    this.mobileNavToggler();
    this.headerScroll();

    $(window).on('load resize', () => {
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        this.navDropdown();
      }, this.debounceInterval);
    });
  }

  headerScroll() {
    if (this.header.length) {
      $(window).on('scroll load', e => {
        const window = $(e.currentTarget);

        this.header.toggleClass('is-scrolled', window.scrollTop() > 100);
      });
    }
  }

  navDropdown() {
    this.nav.each((i, el) => {
      const nav = $(el);
      const navType = nav.data('nav-type') || this.initialNavType;

      if (navType === 'hover') {
        if ($(window).width() > this.breakpoint) {
          this.navType = 'hover';
          this.navDropdownHoverType(nav);
        } else {
          this.navType = 'click';
          this.navDropdownClickType(nav);
        }
      } else {
        this.navType = 'click';
        this.navDropdownClickType(nav);
      }
    });
  }

  navDropdownHoverType(nav) {
    const navLink = nav.find('.js-nav-link');
    const subLinks = nav.find('.js-nav-sublink');

    navLink.on('click', e => {
      const link = $(e.currentTarget);
      const linkHref = link.attr('href');

      if (linkHref.substr(0, 1) === '#') {
        e.preventDefault();
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.navType === 'hover') {
          window.location = linkHref;
        }
      }
    });

    navLink
      .on('mouseover focus', e => {
        const link = $(e.currentTarget);

        if (link.hasClass('has-caret') && $(window).width() > this.breakpoint) {
          const dropdown = link.siblings('.js-nav-dropdown');

          if (this.navDropdowns.not(dropdown).length) {
            this.navDropdowns.not(dropdown).removeClass('is-open');
          }

          if (this.navLinks.not(link).length) {
            this.navLinks.not(link).attr('aria-expanded', false);
          }

          if (!dropdown.hasClass('is-open')) {
            dropdown.addClass('is-open');
            link.addClass('has-dropdown-open').attr('aria-expanded', true);
          }
        }
      })
      .on('mouseout blur', e => {
        if ($(window).width() > this.breakpoint) {
          const toElem = e.toElement || e.relatedTarget;
          const toElement = $(toElem);

          this.hideDropdownsOnMouseOut(toElement);
        }
      });

    subLinks.on('mouseout blur', e => {
      if ($(window).width() > this.breakpoint) {
        const toElem = e.toElement || e.relatedTarget;
        const toElement = $(toElem);

        this.hideDropdownsOnMouseOut(toElement);
      }
    });
  }

  navDropdownClickType(nav) {
    const navLink = nav.find('.js-nav-link');

    navLink.off('click');
    navLink.on('click', e => {
      const link = $(e.currentTarget);

      if (link.hasClass('has-caret')) {
        e.preventDefault();
        const dropdown = link.siblings('.js-nav-dropdown');

        if (this.navDropdowns.not(dropdown).length) {
          this.navDropdowns.not(dropdown).removeClass('is-open');
        }

        if (this.navLinks.not(link).length) {
          this.navLinks.not(link).attr('aria-expanded', false);
        }

        if (dropdown.hasClass('is-open')) {
          dropdown.removeClass('is-open');
          link.removeClass('has-dropdown-open').attr('aria-expanded', false);
        } else {
          dropdown.addClass('is-open');
          link.addClass('has-dropdown-open').attr('aria-expanded', true);
        }
      }
    });

    $(document).on('click', e => {
      const clickedElement = $(e.target);

      if (
        !clickedElement.hasClass('js-nav-link') &&
        !clickedElement.closest('.js-nav-link').length &&
        !clickedElement.closest('.js-nav-item').length
      ) {
        const openDropdown = this.nav.find('.js-nav-dropdown.is-open');

        if (openDropdown.length) {
          openDropdown.removeClass('is-open');
          openDropdown
            .siblings('.js-nav-link')
            .removeClass('has-dropdown-open')
            .attr('aria-expanded', false);
        }
      }
    });
  }

  hideDropdownsOnMouseOut(toElement) {
    if (
      !toElement.hasClass('js-nav-dropdown') &&
      !toElement.closest('.js-nav-dropdown').length
    ) {
      this.navDropdowns.removeClass('is-open');
      this.navLinks
        .attr('aria-expanded', false)
        .removeClass('has-dropdown-open');
    }
  }

  mobileNavToggler() {
    if (this.navToggler.length) {
      this.navToggler.on('click', e => {
        const toggler = $(e.currentTarget);
        const target = toggler.data('target');
        const navigation = toggler.closest('.js-nav');
        const nav = navigation.find(`#${target}`);

        toggler
          .toggleClass('is-active')
          .attr('aria-expanded', toggler.hasClass('is-active'));

        if (nav.length) {
          if (nav.is(':visible')) {
            nav.show();
          }
          nav.toggleClass('is-open');
        }
      });
    }
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js